<template>
  <el-dialog
    :title="editParams.watch ? '查看' :'颁发/保存合格证'"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form :model="form" :rules="rule" ref="form" :disabled="editParams.watch">
      <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
        <el-input
          v-model="form.name"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别" :label-width="formLabelWidth" prop="sex">
        <el-select v-model="form.sex">
          <el-option v-for="(item,idx) in xb" :key="idx" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生日期" :label-width="formLabelWidth" prop="birthday">
        <el-date-picker
          v-model="form.birthday"
          :value-format='"yyyy-MM-dd HH:mm:ss"'
          type="date"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="身份证号" :label-width="formLabelWidth" prop="idCard">
        <el-input
          v-model="form.idCard"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="合格证编号" :label-width="formLabelWidth" prop="qualifyNumber">
        <el-input
          v-model="form.qualifyNumber"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="专业岗位名称" :label-width="formLabelWidth">
        <el-input
          v-model="form.majorName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="理论知识考试成绩" :label-width="formLabelWidth">
        <el-input
          v-model="form.theory"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作技能考核成绩" :label-width="formLabelWidth">
        <el-input
          v-model="form.operation"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="综合评定成绩" :label-width="formLabelWidth">
        <el-input
          v-model="form.synthesize"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="职业资格" :label-width="formLabelWidth">
        <el-input
          v-model="form.qualification"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="技能等级" :label-width="formLabelWidth">
        <el-select v-model="form.level">
          <el-option v-for="(item,idx) in selectJson" :key="idx" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="鉴定中心" :label-width="formLabelWidth">
        <el-input
          v-model="form.identificationCenter"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="证书颁发单位" :label-width="formLabelWidth">
        <el-input
          v-model="form.issuingAuthority"
          readonly
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="数据责任单位" :label-width="formLabelWidth">
        <el-input
          v-model="form.responsibleUnit"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="发证日期" :label-width="formLabelWidth">
        <el-date-picker
          v-model="form.qualifyTime"
          :value-format='"yyyy-MM-dd HH:mm:ss"'
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer" v-if="!editParams.watch">
      <el-button @click="sure(1)">保存信息</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button @click="sure(2)">颁发证书</el-button>
      <!-- <el-button type="primary" @click="sure">确 定</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
import { awardOneCertificate } from '@/api/api'
export default {
  props: {
    studentId: {
      type: String,
      default: function(){
        return ''
      }
    },
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: "130px",
      selectJson:[
        {
          label:'初级',
          value:1
        },{
          label:'中级',
          value:2
        },{
          label:'高级',
          value:3
        }
      ],
      form: {},
      xb:[{
        label:'男',
        value:1
      },{
        label:'女',
        value:2
      }],
      rule: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          },
        ],
        sex: [
          { required: true, message: "请选择性别", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "请输入出生日期", trigger: "blur" }
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          },
        ],
        qualifyNumber: [
          { required: false, message: "请输入合格证编号", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    setOpacity(flg) {
      this.dialogVisible = flg;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    sure(flg){
      //保存 1  颁发2
      this.$refs.form.validate(async (valid) => {
        if (!valid) {

        }else{

          awardOneCertificate({
            id: this.studentId,
            ...this.form,
            operationType:flg
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('成功');
              this.dialogVisible = false;
              this.$emit('success',1)
            } else {
              this.$message.error(message);
            }
          })
        }
      })

    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        if( newValue ){
          let obj = JSON.parse(JSON.stringify(this.editParams));
          if( !obj.qualifyNumber ){
            obj.qualifyNumber = obj.qualifyNewNumber
          }
          if( obj.birthday ){
            obj.birthday = new Date(obj.birthday)
          }
          this.form = obj
        }
      },
    },
  },
};
</script>

<style lang="scss">

.el-dialog__body {
  // max-height: 50vh;
  overflow-y: auto;
}
.red{
  color: red;
  margin-left: 130px;
}
</style>
